<template>
  <b-card title="Logger List">
    <b-card-text>This is the Logger List page. The feature is under construction.</b-card-text>
  </b-card>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
  },
}
</script>
